/**
 * Name tags and edge arrows for crewmates: DOM elements moved with CSS transforms, one pair per
 * crewmate on the planet.
 */
import './tags.css';

const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';

export interface Tag {
  readonly tag: HTMLDivElement;
  readonly edge: HTMLDivElement;
  setLook(name: string, color: string): void;
  /** On screen at (x, y) in CSS pixels. */
  showAt(x: number, y: number): void;
  /** Off screen: an arrow at the edge, pointing at angle `rad`. */
  showEdge(x: number, y: number, rad: number): void;
  hide(): void;
  remove(): void;
}

export function createTag(container: HTMLElement): Tag {
  const tag = document.createElement('div');
  tag.className = 'tag glass';
  const edge = document.createElement('div');
  edge.className = 'edge glass';
  edge.innerHTML = `${ARROW}<span></span>`;
  const label = edge.querySelector('span');
  const arrow = edge.querySelector('svg');
  container.append(tag, edge);
  tag.hidden = true;
  edge.hidden = true;
  return {
    tag,
    edge,
    setLook(name, color) {
      tag.textContent = name;
      tag.style.setProperty('--c', color);
      edge.style.setProperty('--c', color);
      if (label) label.textContent = name;
    },
    showAt(x, y) {
      tag.hidden = false;
      edge.hidden = true;
      tag.style.transform = `translate(${x}px, ${y - 6}px) translate(-50%, -100%)`;
    },
    showEdge(x, y, rad) {
      tag.hidden = true;
      edge.hidden = false;
      edge.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      if (arrow) arrow.style.transform = `rotate(${rad}rad)`;
    },
    hide() {
      tag.hidden = true;
      edge.hidden = true;
    },
    remove() {
      tag.remove();
      edge.remove();
    },
  };
}
